<template>
  <div
    class="PropertyProjectInformationDetailList vheight container-boot PublicInformationDetail"
  >
    <el-tabs type="border-card">
      <el-tab-pane label="项目详情">
        <div
          class="basInfo-table"
          v-loading="detailLoading"
          element-loading-text="数据正在加载中，请稍候"
        >
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">项目编号</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.EaAreaExternalCode || '--' }}
            </div>
            <!-- </div>
          <div class="row"> -->
            <div class="col-define col-tips col-xs-2 col-md-2">宗地号</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.LandNumber ? ProjectDetail.LandNumber : '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">项目名称</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.EaAreaName || '--' }}
            </div>
            <div class="col-define col-tips col-xs-2 col-md-2">项目类型</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.EBuildingTypeName || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">所属行政区</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.PropertyCantonName || '--' }}
            </div>
            <div class="col-define col-tips col-xs-2 col-md-2">所属街道</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.StreetOfficeName || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">所属社区</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.ResidentsCommitteeName || '--' }}
            </div>
            <div class="col-define col-tips col-xs-2 col-md-2">项目地址</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.PrejectAddress || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">建筑面积</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.CoveredArea || '--' }}
            </div>
            <div class="col-define col-tips col-xs-2 col-md-2">占地面积</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.FloorArea || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">项目东至</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.EastScope ? ProjectDetail.EastScope : '--' }}
            </div>
            <div class="col-define col-tips col-xs-2 col-md-2">项目南至</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.SouthScope ? ProjectDetail.SouthScope : '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">项目西至</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.WestScope ? ProjectDetail.WestScope : '--' }}
            </div>
            <div class="col-define col-tips col-xs-2 col-md-2">项目北至</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.NorthScope ? ProjectDetail.NorthScope : '--' }}
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">项目其他</div>
            <div class="col-define col-xs-4 col-md-4">{{ProjectDetail.PrjectOther}}</div>
          </div> -->
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">竣工日期</div>
            <div class="col-define col-xs-4 col-md-4">
              <span v-if="ProjectDetail.PropertyCompletionDate">{{
                ProjectDetail.PropertyCompletionDate
                  | formatDate('yyyy-MM-dd hh:mm:ss')
              }}</span>
              <span v-else>--</span>
            </div>
            <div class="col-define col-tips col-xs-2 col-md-2">
              开发建设单位
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{
                ProjectDetail.BuildUnitName ? ProjectDetail.BuildUnitName : '--'
              }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">入伙日期</div>
            <div class="col-define col-xs-4 col-md-4">
              <span v-if="ProjectDetail.AccessionDate">{{
                ProjectDetail.AccessionDate | formatDate('yyyy-MM-dd hh:mm:ss')
              }}</span>
              <span v-else>--</span>
            </div>
            <div class="col-define col-tips col-xs-2 col-md-2">
              物业服务企业
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.PropertyName || '--' }}
            </div>
          </div>
          <div class="row">
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">物业服务用房地址</div>
            <div class="col-define col-xs-4 col-md-4">{{ProjectDetail.propertyUseAddress}}</div> -->
            <div class="col-define col-tips col-xs-2 col-md-2">项目负责人</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.PropertyManager || '--' }}
            </div>
            <!-- </div> -->
            <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">物业服务用房面积</div>
            <div class="col-define col-xs-4 col-md-4">{{ProjectDetail.ServiceArea}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">负责人联系电话</div>
            <div class="col-define col-xs-4 col-md-4">{{ProjectDetail.PropertyManagerTel}}</div>
          </div> -->
            <!-- <div class="row"> -->
            <div class="col-define col-tips col-xs-2 col-md-2">
              是否成立业主大会
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ProjectDetail.IsCommitte ? '是' : '否' }}
            </div>
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">业委会名称</div>
            <div class="col-define col-xs-4 col-md-4">{{ProjectDetail.OwnerTeamName}}</div> -->
          </div>
          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">总栋数</div>
            <div class="col-define col-xs-4 col-md-4">{{ProjectDetail.BuildTotal}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">总户数</div>
            <div class="col-define col-xs-4 col-md-4">{{ProjectDetail.TotalHouses}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">是否属于城中村</div>
            <div class="col-define col-xs-4 col-md-4">{{ProjectDetail.IsCity ? "是" : "否"}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">是否属于老旧小区</div>
            <div class="col-define col-xs-4 col-md-4">{{ProjectDetail.IsOld ? "是" : "否"}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">项目描述</div>
            <div class="col-define col-xs-4 col-md-4">{{ProjectDetail.PrejectRemark}}</div>
          </div> -->
        </div>
      </el-tab-pane>
      <el-tab-pane label="在管物业企业信息" v-if="RealtyMgeComDetail.OrgCode">
        <div class="basInfo-table">
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              统一社会信用代码
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ RealtyMgeComDetail.OrgCode || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              物业企业名称
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ RealtyMgeComDetail.OrgName || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              物业办公地址
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ RealtyMgeComDetail.Address || '--' }}
            </div>
          </div>
          <div class="row">
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">营业执照注册号</div>
            <div class="col-define col-xs-4 col-md-4">{{RealtyMgeComDetail.BusinessLicenseNo}}</div>-->
            <div class="col-define col-tips col-xs-2 col-md-2">法定代表人</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ RealtyMgeComDetail.LegalRep || '--' }}
            </div>
            <div class="col-define col-tips col-xs-2 col-md-2">
              注册资本（万元）
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ RealtyMgeComDetail.RegCapital || '--' }}
            </div>
          </div>
          <!-- <div class="row">

            <div class="col-define col-tips col-xs-2 col-md-2">联系电话</div>
            <div class="col-define col-xs-4 col-md-4">{{RealtyMgeComDetail.OfficePhone}}</div>
          </div>
          <div class="row">

            <div class="col-define col-tips col-xs-2 col-md-2">联系手机</div>
            <div class="col-define col-xs-4 col-md-4">{{RealtyMgeComDetail.LegalRepTel}}</div>
          </div> -->
          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">营业执照有效期</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{RealtyMgeComDetail.BusinessLicenseValidTime | formatDate('yyyy-MM-dd')}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">注册辖区</div>
            <div class="col-define col-xs-4 col-md-4">{{RealtyMgeComDetail.RegisteredArea | getCanton}}</div>
          </div> -->
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              登记注册类型
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{
                RealtyMgeComDetail.RegistrationType
                  ? registrationType[RealtyMgeComDetail.RegistrationType]
                  : '--'
              }}
            </div>
            <div class="col-define col-tips col-xs-2 col-md-2">成立日期</div>
            <div class="col-define col-xs-4 col-md-4">
              <span v-if="RealtyMgeComDetail.RegisteredDate">{{
                RealtyMgeComDetail.RegisteredDate | formatDate('yyyy-MM-dd')
              }}</span>
              <span v-else>--</span>
            </div>
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">企业类别</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{companyType[RealtyMgeComDetail.CompanyType]}}</div> -->
          </div>
          <!-- <div class="row"> -->
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">机构类型</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{organizationType[RealtyMgeComDetail.OrganizationType]}}</div> -->
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">原资质等级</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ RealtyMgeComDetail.LicenseLevel || '--' }}
            </div>
            <div class="col-define col-tips col-xs-2 col-md-2">
              原资质证书编号
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ RealtyMgeComDetail.LicenseNo || '--' }}
            </div> -->
          <!-- </div> -->
          <!-- <div class="row">

            <div class="col-define col-tips col-xs-2 col-md-2">资质证书发证机关</div>
            <div class="col-define col-xs-4 col-md-4">{{RealtyMgeComDetail.IcenseIssueOrg}}</div>
          </div> -->
          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">企业传真</div>
            <div class="col-define col-xs-4 col-md-4">{{RealtyMgeComDetail.FaxNumber}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">email</div>
            <div class="col-define col-xs-4 col-md-4">{{RealtyMgeComDetail.Email}}</div>
          </div> -->
          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">控股情况</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{holdingSituation[RealtyMgeComDetail.HoldingSituation]}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">执行会计制度类别</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{accountingType[RealtyMgeComDetail.AccountingType]}}</div>
          </div>           -->
          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">主营业范围</div>
            <div class="col-define col-xs-4 col-md-4">{{RealtyMgeComDetail.OperationScope}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">其他营业范围</div>
            <div class="col-define col-xs-4 col-md-4">{{RealtyMgeComDetail.MainBusiness}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">企业概况</div>
            <div class="col-define col-xs-4 col-md-4">{{RealtyMgeComDetail.CompanyOverview}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">业绩介绍</div>
            <div class="col-define col-xs-4 col-md-4">{{RealtyMgeComDetail.Achievement}}</div>
          </div> -->
        </div>
      </el-tab-pane>
      <el-tab-pane label="业主大会和业委会信息" v-if="ZjjOwnerTeamVo.Tyshxydm">
        <div class="basInfo-table">
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              统一社会信用代码
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ZjjOwnerTeamVo.Tyshxydm || '--' }}
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">管理项目名称</div>
            <div class="col-define col-xs-4 col-md-4">{{ProjectDetail.EaAreaName}}</div>
          </div> -->
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              业主大会名称
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ZjjOwnerTeamVo.Yzdhmc || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              业主大会地址
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ZjjOwnerTeamVo.Yzdhdz || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              业主大会负责人
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ZjjOwnerTeamVo.Yzdhfzr || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              业主大会统一代码证有效期
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ZjjOwnerTeamVo.Yzdhdmzyxq || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">业委会届别</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ZjjOwnerTeamVo.Yzdhjb || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              业委会任期起止时间
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ZjjOwnerTeamVo.Ywhrqjzsj || '--' }}
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              业委会运作状态
            </div>
            <div class="col-define col-xs-4 col-md-4">
              <template>
                <span v-if="ZjjOwnerTeamVo.RunningState == 1">正常运作</span>
                <span v-else-if="ZjjOwnerTeamVo.RunningState == 2"
                  >非正常运作（已过期）</span
                >
                <span v-else-if="ZjjOwnerTeamVo.RunningState == 3"
                  >非正常运作（已解散）</span
                >
                <span v-else>--</span>
              </template>
            </div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">
              业委会执行秘书
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ ZjjOwnerTeamVo.Ywhzxms || '--' }}
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">成立日期</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{OwnerCommittee.FoundedTime | formatDate('yyyy-MM-dd') }}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">第几届业委会</div>
            <div class="col-define col-xs-4 col-md-4">{{OwnerCommittee.Tenure}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">任期</div>
            <div class="col-define col-xs-4 col-md-4">{{OwnerCommittee.SectionTime}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">任期开始日期</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{OwnerCommittee.FoundedTime | formatDate('yyyy-MM-dd')}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">任期结束日期</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{OwnerCommittee.ExpirationTime | formatDate('yyyy-MM-dd')}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">联系人</div>
            <div class="col-define col-xs-4 col-md-4">{{OwnerCommittee.ContactPerson}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">联系电话</div>
            <div class="col-define col-xs-4 col-md-4">{{OwnerCommittee.ContactTel}}</div>
          </div> -->
        </div>
      </el-tab-pane>
      <!-- <el-tab-pane label="在管负责人信息">
        <div class="basInfo-table">
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">姓名</div>
            <div class="col-define col-xs-4 col-md-4">{{Employee.FullName}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">性别</div>
            <div class="col-define col-xs-4 col-md-4">{{Employee.Gender}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">证件号码</div>
            <div class="col-define col-xs-4 col-md-4">{{Employee.IDCardNumber}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">物业企业名称</div>
            <div class="col-define col-xs-4 col-md-4">{{Employee.OrgName}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">物业企业代码</div>
            <div class="col-define col-xs-4 col-md-4">{{Employee.OrgCode}}</div>
          </div> -->
      <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">联系地址</div>
            <div class="col-define col-xs-4 col-md-4">{{propertyEnterpriseDetails.Address}}</div>
          </div> -->
      <!-- <div class="row"> -->
      <!-- <div class="col-define col-tips col-xs-2 col-md-2">人员类型</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{Employee.Job && AllTypeArray[0][Employee.Job] || "暂无" }}</div> -->
      <!-- <div class="col-define col-tips col-xs-2 col-md-2">联系地址</div>
            <div class="col-define col-xs-4 col-md-4">{{propertyEnterpriseDetails.Address}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">出生日期</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{Employee.BirthDay | formatDate('yyyy-MM-dd')}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">文化程度</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{Employee.Education && AllTypeArray[1][Employee.Education] || "暂无" }}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">职务</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{Employee.Job &&AllTypeArray[0][Employee.Job] || "暂无"}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">专业</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{Employee.MajorType && AllTypeArray[2][Employee.MajorType] || "暂无"}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">职称等级</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{Employee.MajorTypeLevel && AllTypeArray[3][Employee.MajorTypeLevel] || "暂无"}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">上岗证书名称</div>
            <div class="col-define col-xs-4 col-md-4">{{Employee.QualificationName}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">上岗证书编号</div>
            <div class="col-define col-xs-4 col-md-4">{{Employee.QualificationCode}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">从事物管年限</div>
            <div class="col-define col-xs-4 col-md-4">{{Employee.WorkYears}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">邮箱</div>
            <div class="col-define col-xs-4 col-md-4">{{Employee.Email}}</div>
          </div>
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">劳务合同开始日期</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{Employee.ContractSTime | formatDate('yyyy-MM-dd')}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">劳务合同结束日期</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{Employee.ContractETime | formatDate('yyyy-MM-dd')}}</div>
          </div>
        </div>
      </el-tab-pane> -->
      <el-tab-pane
        label="业委会成员信息"
        v-if="OwnerCommitteeMember.length != 0"
      >
        <div class="basInfo-table">
          <el-table :data="OwnerCommitteeMember" style="width: 100%">
            <el-table-column
              type="index"
              width="50"
              :formatter="formatter"
            ></el-table-column>
            <el-table-column
              prop="OwnerName"
              label="姓名"
              width="180"
              :formatter="formatter"
            ></el-table-column>
            <el-table-column label="性别" width="180">
              <template slot-scope="scope">
                {{ scope.row.OwnerSex == 1 ? '男' : '女' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="OwnerNationLabel"
              label="民族"
              width="180"
              :formatter="formatter"
            ></el-table-column>
            <el-table-column
              prop="OwnerTeamMemberRoleName"
              label="分工"
              :formatter="formatter"
            ></el-table-column>
            <!-- <el-table-column prop="OwnerPhone" label="手机号码" width="180"></el-table-column>
            <el-table-column prop="Address" label="地址"></el-table-column> -->
          </el-table>
          <div class="footer ub ub-pe">
            <div class="page">
              <ps-page :page="page" @getData="getComplains()"></ps-page>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="PublicInformationDetail-footer"></div>
  </div>
</template>

<script>
import { OpenControllerSvr } from '@/service/OpenControllerSvr/OpenControllerSvr.js';
import { PropertyProjectControllerSvr } from '@/service/PropertyProjectControllerSvr/PropertyProjectControllerSvr.js';
import { BuildUnitInfoControllerSvr } from '@/service/BuildUnitInfoControllerSvr/BuildUnitInfoControllerSvr.js';
import { OrgBaseMgmtControllerSvr } from '@/service/OrgBaseMgmtControllerSvr.js';
import { CommonControllerSvr } from '@/service/CommonControllerSvr/CommonControllerSvr.js';
import {
  registrationType,
  holdingSituation,
  licenseLevel,
  accountingType,
  organizationType,
  companyType,
  ProjecType,
} from '@/enum/propertyEnterprise.js';
import { ArticleQueryPara } from '@/models/queryparams/ArticleQueryPara.js';
import { headerredraw } from '@/mixin/headerredraw';
import { Page } from '@/models/page';
import { mapState, mapActions, mapMutations } from 'vuex';
import { EnumController } from '@/service/EnumController/EnumController.js';

export default {
  name: 'EmployeeDetailInformation',
  metaInfo: {
    title: '业主大会和业委会查询',
    meta: [
      {
        name: 'viewport',
        content:
          'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no',
      },
      { name: 'SiteName', content: '深圳市住房和建设局网站' },
      { name: 'SiteDomain', content: 'zjj.sz.gov.cn' },
      { name: 'SiteIDCode', content: '4403000005' },
      { name: 'ColumnName', content: '物业管理政策专题' },
      {
        name: 'ColumnDescription',
        content: '该栏目公布物业管理政策专栏的信息。',
      },
      { name: 'ColumnKeywords', content: '物业管理政策专栏' },
      { name: 'ColumnType', content: '其他' },
    ],
  },
  components: {},
  props: {},
  mixins: [headerredraw],
  data() {
    return {
      keyWords: '',
      dialogVisible: false,
      orgCode: '',
      eaAreaCode: '',
      OwnerTeamCode: '',
      keyID: '',
      ProjectDetail: {},
      RealtyMgeComDetail: {},
      OwnerCommittee: {},
      ZjjOwnerTeamVo: {}, //业主大会和业委会信息
      Employee: {},
      OwnerCommitteeMember: [],
      BuildUnit: '',
      projecType: new ProjecType(),
      PertyMgeInfo: '',
      holdingSituation: new holdingSituation(),
      licenseLevel: new licenseLevel(),
      accountingType: new accountingType(),
      organizationType: new organizationType(),
      companyType: new companyType(),
      AllTypeArray: [],
      adminOptions: [],
      paraNameArray: [
        '职务配置',
        '最高学历配置',
        '专业分类配置',
        '专业分类等级配置',
      ],
      propertyEnterpriseDetails: {},
      startIndex: 0,
      maxSize: 20,
      page: new Page(),
      detailLoading: false,
    };
  },
  computed: {
    ...mapState(['token', 'tabsRouter']),
  },
  created() {
    this.OpenControllerSvr = new OpenControllerSvr();
    this.BuildUnitInfoControllerSvr = new BuildUnitInfoControllerSvr();
    this.OrgBaseMgmtControllerSvr = new OrgBaseMgmtControllerSvr();
    this.PropertyProjectControllerSvr = new PropertyProjectControllerSvr();
    this.CommonControllerSvr = new CommonControllerSvr();
    this.EnumController = new EnumController();
    this.getAllType(this.paraNameArray);
  },
  mounted() {
    this.orgCode = this.$route.query.orgCode;
    this.eaAreaCode = this.$route.query.eaAreaCode;
    this.OwnerTeamCode = this.$route.query.ownerTeamCode || '';
    this.keyID = this.$route.query.keyID;
    this.getProjectDetails();
    this.getRealtyMgeComDetail();
    this.getOwnerCommittee();
    // 此接口不再调用
    // this.getEmployeeByCode();
    this.getOwnerCommitteeMember();

    // this.getData(); PropertyProjectInformationDetailList
  },
  methods: {
    ...mapActions({
      DeleTabsRouter: 'DeleTabsRouter',
    }),
    //空数据处理
    formatter(row, column, cellValue, index) {
      return cellValue === null || cellValue === '' ? '--' : cellValue;
    },
    //获取所有值的类
    getAllType(paraNameArray) {
      let temporary;
      paraNameArray.map((currentValue, inedx) => {
        this.CommonControllerSvr.GetConfigValueList(currentValue)
          .then(
            (res) => {
              temporary = [...[]];
              temporary[0] = '1';
              for (let { Key: key, Value: value } of res) {
                temporary[value] = key;
              }
              this.AllTypeArray[inedx] = temporary;
            },
            (err) => {
              this.$message({
                message: err.Msg,
                type: 'error',
              });
            }
          )
          .catch(() => {});
      });
    },
    //获取物业企业
    getproPertyMgeInfo() {
      this.PropertyMgeInfoControllerSvr.GetproPertyMgeInfo(
        this.token,
        this.orgCode
      )
        .then(
          (res) => {
            this.PertyMgeInfo = res.OrgName;
          },
          (err) => {
            this.$message({
              message: err.Msg,
              type: 'error',
            });
          }
        )
        .catch(() => {});
    },
    // 获取项目详情
    getProjectDetails() {
      this.detailLoading = true;
      this.PropertyProjectControllerSvr.GetProjectDetails(this.eaAreaCode)
        .then(
          (res) => {
            this.detailLoading = false;
            this.ProjectDetail = res;
            //var mtel = tel.substr(0, 3) + '****' + tel.substr(7);
            if (this.ProjectDetail.PropertyManagerTel !== null) {
              this.ProjectDetail.PropertyManagerTel =
                this.ProjectDetail.PropertyManagerTel.substr(0, 3) +
                '****' +
                this.ProjectDetail.PropertyManagerTel.substr(7);
            }
          },
          (err) => {
            this.detailLoading = false;
            this.$message({
              message: err.Msg,
              type: 'error',
            });
          }
        )
        .catch(() => {
          this.detailLoading = false;
        });
    },
    //获取物业企业名称
    getRealtyMgeComDetailData() {
      this.OrgBaseMgmtControllerSvr.GetRealtyMgeComDetail(
        this.token,
        this.orgCode
      )
        .then(
          (res) => {
            this.propertyEnterpriseDetails = res.RealtyMgeComObj;
          },
          (err) => {
            this.$message({
              message: err.Msg,
              type: 'error',
            });
          }
        )
        .catch(() => {});
    },
    // 物业企业
    getRealtyMgeComDetail() {
      this.OpenControllerSvr.getRealtyMgeComDetail(this.orgCode)
        .then(
          (res) => {
            this.RealtyMgeComDetail = res.RealtyMgeComObj;
            this.RealtyMgeComDetail.Achievement =
              res.RealtyMgeComPropertyObj.Achievement;
            if (this.RealtyMgeComDetail.OfficePhone) {
              this.RealtyMgeComDetail.OfficePhone =
                this.RealtyMgeComDetail.OfficePhone.substr(0, 3) +
                '****' +
                this.RealtyMgeComDetail.OfficePhone.substr(
                  this.RealtyMgeComDetail.OfficePhone.length - 4
                );
            }
            if (this.RealtyMgeComDetail.LegalRepTel) {
              this.RealtyMgeComDetail.LegalRepTel =
                this.RealtyMgeComDetail.LegalRepTel.substr(0, 3) +
                '****' +
                this.RealtyMgeComDetail.LegalRepTel.substr(
                  this.RealtyMgeComDetail.LegalRepTel.length - 4
                );
            }
          },
          (err) => {
            this.$message({
              message: err.Msg,
              type: 'error',
            });
          }
        )
        .catch(() => {});
    },
    // 业主委员会
    getOwnerCommittee() {
      this.OpenControllerSvr.getOwnerTeamByEaAreaCode(this.eaAreaCode)
        .then(
          (res) => {
            this.OwnerCommittee = res;
            this.OwnerCommittee.ContactTel =
              this.OwnerCommittee.ContactTel.substr(0, 3) +
              '****' +
              this.OwnerCommittee.ContactTel.substr(7);
          },
          (err) => {
            this.$message({
              message: err.Msg,
              type: 'error',
            });
          }
        )
        .catch(() => {});
      this.OpenControllerSvr.getZjjOwnerTeamVoByEaAreaCode(this.eaAreaCode)
        .then(
          (res) => {
            this.ZjjOwnerTeamVo = res;
          },
          (err) => {
            this.$message({
              message: err.Msg,
              type: 'error',
            });
          }
        )
        .catch(() => {});
    },
    // 在管负责人 此接口不再调用
    // getEmployeeByCode() {
    //   this.OpenControllerSvr.getPropertyManagerByEaAreaCode(this.eaAreaCode)
    //     .then(
    //       (res) => {
    //         this.Employee = res;
    //         this.Employee.IDCardNumber =
    //           this.Employee.IDCardNumber.substr(0, 3) +
    //           '*****' +
    //           this.Employee.IDCardNumber.substr(
    //             this.Employee.IDCardNumber.length - 3
    //           );
    //       },
    //       (err) => {
    //         this.$message({
    //           message: err.Msg,
    //           type: 'error',
    //         });
    //       }
    //     )
    //     .catch(() => {});
    // },
    // 业委会成员信息
    getOwnerCommitteeMember() {
      if (!this.OwnerTeamCode) {
        return;
      }
      this.OpenControllerSvr.getOwnerCommitteeMemberListForOut(
        this.OwnerTeamCode,
        '',
        '',
        '',
        (this.page.currentPage - 1) * this.page.currtNum,
        this.page.currtNum,
        true
      )
        .then(
          (res) => {
            this.OwnerCommitteeMember = res._Items;
          },
          (err) => {
            this.$message({
              message: err.Msg,
              type: 'error',
            });
          }
        )
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.PublicInformationDetail {
  height: 100%;
  width: 100%;
  .basInfo-table {
    overflow: auto;
    .row {
      margin-right: 0;
      margin-left: 0;
      @media screen and (max-width: 992px) {
        flex-wrap: wrap !important;
      }
      .col-define {
        font-size: 14px;
        line-height: 42px;
        min-width: 150px;
        overflow: hidden;
        color: #666;
        border-bottom: 1px solid #e2e2e2;
        .col-chld {
          display: inline-block;
          width: 25%;
          & > div:nth-child(1) {
            display: inline-block;
            width: 30%;
            vertical-align: top;
          }
          & > div:nth-child(2) {
            display: inline-block;
            width: 70%;
          }
        }
      }
      .col-define:nth-child(2n) {
        flex: 1;
        border-right: 1px dotted #e2e2e2;
        padding-left: 24px;
      }

      .col-define:nth-child(2n-1) {
        text-align: right;
      }

      .col-tips {
        border-right: 1px dotted #e2e2e2;
      }
    }
  }
  .PublicInformationDetail-footer {
    text-align: right;
    margin: 20px;
  }
}
.no-data {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 530px;
}
.InformationDetailPropertyEnterprisesList {
  width: 100%;
  box-sizing: border-box;
  .function {
    min-width: 400px;
  }
  .container-boot {
    width: 100%;
    padding-right: 10px;
    padding-left: 10px;
    transition: height 0.3s;
    .container-header {
      width: 100%;
      padding-top: 10px;
      box-sizing: border-box;
    }
    .grid {
      height: calc(100% - 30px);
    }
  }
  .footer {
    display: flex;
    flex-direction: row-reverse;
    margin-right: 10px;
    .fun {
      font-size: 14px;
      color: #409eff;
      cursor: pointer;
      .delete {
        margin-left: 20px;
      }
    }
  }
}
</style>
